import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import _cloneDeep from 'lodash.clonedeep'

import settingsAct from '../../../../../redux/settings/actions'
import { updateModalError as updateModalHeaderError } from 'redux/smartchat/header/actions'
import { getProcessDetail, updateModalActionRef, updateModalError } from 'redux/smartchat/details/actions'
import ProcessContentUI from './ProcessContentUI'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ProcessContent = ({ isAdvanceModeEnabled }) => {
  const { processesList, labelsList, currentProcess, modalHeaderLoading, modalHeaderError, processDetail, modalLoading, modalError, loading, error, settings } = useSelector(store => ({
    processesList: store.smartchatHeader.processesList,
    labelsList: store.smartchatHeader.labelsList,
    currentProcess: store.smartchatHeader.currentProcess,
    modalHeaderLoading: store.smartchatHeader.modalLoading,
    modalHeaderError: store.smartchatHeader.modalError,
    processDetail: store.smartchatDetails.processDetail,
    modalLoading: store.smartchatDetails.modalLoading,
    modalError: store.smartchatDetails.modalError,
    loading: store.smartchatDetails.loading,
    error: store.smartchatDetails.error,
    settings: store.settings
  }), shallowEqual)
  const dispatch = useDispatch()
  const [containerName, setContainerName] = useState('')
  const [selectedContainerData, setSelectedContainerData] = useState({})
  const [isOpenActionModal, setIsOpenActionModal] = useState(false)
  const [isOpenDeleteActionModal, setIsOpenDeleteActionModal] = useState(false)
  const [isOpenAddContainerModal, setIsOpenAddContainerModal] = useState(false)
  const [isOpenCopyContainerModal, setIsOpenCopyContainerModal] = useState(false)
  const [isOpenConfirmCopyContainerModal, setIsOpenConfirmCopyContainerModal] = useState(false)
  const [isOpenDeleteContainerModal, setIsOpenDeleteContainerModal] = useState(false)
  const [labelModal, setLabelModal] = useState({ isOpen: false, mode: '', labelId: '' })
  const [copyContainerValue, setCopyContainerValue] = useState(null)
  const smartChatCollapseDefault = {
    processId: currentProcess,
    onNewProcess: { isOpen: true },
    onProcess: [],
    onLeaveProcess: { isOpen: true }
  }
  const [smartChatCollapse, setSmartChatCollapse] = useState(settings.smartChatCollapse.find(it => it.processId === currentProcess) || smartChatCollapseDefault)

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && currentProcess) {
      dispatch(getProcessDetail({ processId: currentProcess }))
      setSmartChatCollapse(settings.smartChatCollapse.find(it => it.processId === currentProcess) || smartChatCollapseDefault)
    }

    return () => isSubscribed = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProcess])

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      const _smartChatCollapse = _cloneDeep(smartChatCollapse)

      if (processDetail.onProcess) {
        processDetail.onProcess.forEach(process => {
          if (!_smartChatCollapse.onProcess.find(it => it.containerId === process.containerId)) {
            _smartChatCollapse.onProcess.push({ containerId: process.containerId, isOpen: true })
          }
        })
      }

      setSmartChatCollapse(_smartChatCollapse)
    }

    return () => isSubscribed = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processDetail])

  const toggleActionModal = (modalActionRef) => {
    if (modalError) dispatch(updateModalError(null))
    if (!isOpenActionModal) dispatch(updateModalActionRef(modalActionRef))
    setIsOpenActionModal(!isOpenActionModal)
  }

  const toggleDeleteActionModal = (modalActionRef) => {
    if (modalError) dispatch(updateModalError(null))
    if (!isOpenDeleteActionModal) {
      dispatch(updateModalActionRef(modalActionRef))
    } else {
      dispatch(updateModalActionRef({}))
    }
    setIsOpenDeleteActionModal(!isOpenDeleteActionModal)
  }

  const toggleAddContainerModal = () => {
    if (modalError) dispatch(updateModalError(null))
    if(!isOpenAddContainerModal) setContainerName('')
    setIsOpenAddContainerModal(!isOpenAddContainerModal)
  }

  const toggleCopyContainerModal = (containerData) => {
    if (modalError) dispatch(updateModalError(null))
    containerData ? setSelectedContainerData(containerData) : setSelectedContainerData({})
    if (!isOpenCopyContainerModal) setCopyContainerValue(null)
    setIsOpenCopyContainerModal(!isOpenCopyContainerModal)
  }

  const toggleConfirmCopyContainerModal = () => {
    if (modalError) dispatch(updateModalError(null))
    setIsOpenConfirmCopyContainerModal(!isOpenConfirmCopyContainerModal)
  }

  const toggleDeleteContainerModal = (containerData) => {
    if (modalError) dispatch(updateModalError(null))
    containerData ? setSelectedContainerData(containerData) : setSelectedContainerData({})
    setIsOpenDeleteContainerModal(!isOpenDeleteContainerModal)
  }

  const toggleLabelModal = (modalData = {}) => {
    const { mode = '', labelId = '' } = modalData
    if (modalHeaderError) dispatch(updateModalHeaderError(null))
    setLabelModal(prevState => ({ ...prevState,  isOpen: !prevState.isOpen, mode, labelId }))
  }

  const toggleDeleteLabelModal = (modalData = {}) => {
    const { labelId = '' } = modalData
    if (modalHeaderError) dispatch(updateModalHeaderError(null))
    setLabelModal(prevState => ({ ...prevState,  isOpenDelete: !prevState.isOpenDelete, labelId }))
  }

  const onChangeSmartChatCollapse = ({ containerType, containerId }) => {
    const temp = _cloneDeep(smartChatCollapse)

    // Local update
    const _data = _cloneDeep(smartChatCollapse)
    if (['onNewProcess', 'onLeaveProcess'].includes(containerType)) {
      _data[containerType] = { isOpen: !_data[containerType].isOpen }
    } else {
      _data[containerType].forEach(it => {
        if (it.containerId === containerId) it.isOpen = !it.isOpen
      })
    }
    setSmartChatCollapse(_data)

    // Backend update
    const storeData = _cloneDeep(settings.smartChatCollapse) || []
    storeData.forEach(it => {
      if (it.processId === currentProcess) {
        if (['onNewProcess', 'onLeaveProcess'].includes(containerType)) {
          it[containerType] = { isOpen: !it[containerType].isOpen }
        } else {
          it[containerType].forEach(it2 => {
            if (it2.containerId === containerId) it2.isOpen = !it2.isOpen
          })
        }
      }
    })
    if (!storeData.find(it => it.processId === currentProcess)) storeData.push(_data)

    // Send to backend
    dispatch(settingsAct.set({ smartChatCollapse: storeData }))
      .catch(() => setSmartChatCollapse(temp))
  }

  const handleAllCollapse = (mode) => {
    const isOpen = mode === 'expand' ? true : false
    const temp = _cloneDeep(smartChatCollapse)

    // Local update
    const _data = _cloneDeep(smartChatCollapse)
    _data.onNewProcess = { isOpen }
    _data.onProcess.forEach(it => it.isOpen = isOpen)
    _data.onLeaveProcess = { isOpen }
    setSmartChatCollapse(_data)

    // Backend update
    const storeData = _cloneDeep(settings.smartChatCollapse) || []
    storeData.forEach(it => {
      if (it.processId === currentProcess) {
        it.onNewProcess = { isOpen }
        it.onProcess.forEach(it2 => it2.isOpen = isOpen)
        it.onLeaveProcess = { isOpen }
      }
    })
    if (!storeData.find(it => it.processId === currentProcess)) storeData.push(_data)

    // Send to backend
    dispatch(settingsAct.set({ smartChatCollapse: storeData }))
      .catch(() => setSmartChatCollapse(temp))
  }

  const copyContainerOptions = processesList.map(process => ({ value: process._id, label: process.processName }))

  if (loading) return <div className='containerSpinner' style={{ height:'10%' }}> <Nixi1Spinner height='15vh' /> </div>  

  if (error) return <p className='error-message'>{I18n.t(error.message)}</p>

  return (
    <ProcessContentUI
      processName={processesList.find(process => process._id === currentProcess)?.processName}
      labelsList={labelsList}
      labelModal={labelModal}
      processLabels={processesList.find(process => process._id === currentProcess)?.labels || []}
      processDetail={processDetail}
      containerName={containerName}
      setContainerName={setContainerName}
      selectedContainerData={selectedContainerData}
      isOpenActionModal={isOpenActionModal}
      toggleActionModal={toggleActionModal}
      isOpenDeleteActionModal={isOpenDeleteActionModal}
      toggleDeleteActionModal={toggleDeleteActionModal}
      isOpenAddContainerModal={isOpenAddContainerModal}
      toggleAddContainerModal={toggleAddContainerModal}
      isOpenCopyContainerModal={isOpenCopyContainerModal}
      toggleCopyContainerModal={toggleCopyContainerModal}
      isOpenConfirmCopyContainerModal={isOpenConfirmCopyContainerModal}
      toggleConfirmCopyContainerModal={toggleConfirmCopyContainerModal}
      copyContainerOptions={copyContainerOptions}
      copyContainerValue={copyContainerValue}
      setCopyContainerValue={setCopyContainerValue}
      isAdvanceModeEnabled={isAdvanceModeEnabled}
      isOpenDeleteContainerModal={isOpenDeleteContainerModal}
      toggleDeleteContainerModal={toggleDeleteContainerModal}
      toggleLabelModal={toggleLabelModal}
      toggleDeleteLabelModal={toggleDeleteLabelModal}
      smartChatCollapse={smartChatCollapse}
      onChangeSmartChatCollapse={onChangeSmartChatCollapse}
      handleAllCollapse={handleAllCollapse}
      modalHeaderLoading={modalHeaderLoading}
      modalHeaderError={modalHeaderError}
      modalLoading={modalLoading}
      modalError={modalError}
      dispatch={dispatch}
    />
  )
}

export default ProcessContent
